import { render, staticRenderFns } from "./StoriesWrapper.vue?vue&type=template&id=6a6fee3e&scoped=true&"
import script from "./StoriesWrapper.vue?vue&type=script&lang=js&"
export * from "./StoriesWrapper.vue?vue&type=script&lang=js&"
import style0 from "./StoriesWrapper.vue?vue&type=style&index=0&id=6a6fee3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6fee3e",
  null
  
)

export default component.exports